// Copy from Api.ts:
export enum PrintOptions {
  PrintToExcel = "PrintToExcel",
  PrintToPdf = "PrintToPdf",
  PrintCurrentToPdf = "PrintCurrentToPdf",
  PrintAllToPdfAndZip = "PrintAllToPdfAndZip",
}

